import useCheckPresenter from '@Screens/Checkout/presenter';
import capitalize from 'lodash/capitalize';
import { observer } from 'mobx-react-lite';
import type { FC } from 'react';
import React from 'react';
import type { StyleProp, TextStyle, ViewStyle } from 'react-native';
import { Button } from 'react-native-paper';

type IProps = {
  supplierVisitLink?: string;
  methodId: number;
  title: string;
  color: string;
  method: string;
  buttonStyle?: StyleProp<ViewStyle>;
  contentStyle?: StyleProp<ViewStyle>;
  labelStyle?: StyleProp<TextStyle>;
};

const BuyButton: FC<IProps> = ({
  supplierVisitLink,
  methodId = 0,
  color,
  title,
  method = 'buy',
  buttonStyle = {},
  contentStyle = {},
  labelStyle = {},
}) => {
  const { handleBuyPress } = useCheckPresenter();

  return (
    <Button
      mode='contained'
      uppercase={false}
      color={color}
      onPress={() => handleBuyPress(supplierVisitLink, methodId)}
      style={buttonStyle}
      contentStyle={contentStyle}
      accessibilityLabel={capitalize(method)}
      labelStyle={labelStyle}
    >
      {title}
    </Button>
  );
};

export default observer(BuyButton);
